import { createTheme } from '@mui/material/styles';

import { themeOptions } from './themeOptions.js';

export const theme = createTheme(themeOptions);
